import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Cards from '../../components/Cards/Cards';
import News from './news/news';

const CenteredSection = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0;
  background: #fff;

  & > * {
    max-width: 1200px;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Section5 = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <CenteredSection>
      {isMobile ? <News /> : <Cards />}
    </CenteredSection>
  );
};

export default Section5;
